import { isEmptySlateDocument } from "../../core/constants";

export const getPageHasGeneralContent = (page = {}) => {
  if (!page) {
    return false;
  }
  return (
    page.title ||
    page.image ||
    page.photo ||
    !isEmptySlateDocument(page.content)
  );
};
